export default "__VITE_ASSET__CdZL6qvc__"